import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Usaremos estos íconos para mostrar/ocultar contraseña

const CustomTextInput = ({
  type = "text",
  placeholder = "",
  value,
  onChange,
  label, // Prop para el label opcional
  options = [], // Solo para el select, las opciones se pasan como un array
  valueKey = "value", // Clave para el valor de la opción
  labelKey = "label",
  isRequired = false, // Prop para determinar si el campo es requerido
  login,
  disabled = false,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false); // Estado para mostrar/ocultar contraseña

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="poppins-medium flex flex-col space-y-1 tracking-wider">
      {/* Renderiza el label solo si se pasa como prop */}
      {label && (
        <label className="text-[#8F99A6] text-xs tracking-wider">
          {label}
          {isRequired && <span className="text-[#BF1F2E]">*</span>}{" "}
          {/* Asterisco con el color solicitado */}
        </label>
      )}

      {type === "select" ? (
        <select
          value={value}
          onChange={onChange}
          className={`w-full ${
            login ? "py-2" : "py-4"
          } px-4 rounded-[9px] bg-[#F9FAFB] text-[10px] poppins-regular placeholder-[#C9C9C9] focus:outline-none focus:ring-2 focus:ring-blue-500 tracking-wider`}
          {...props}
          style={{ color: value === "" ? "#C9C9C9" : "" }}
          disabled={disabled}
        >
          {/* Mapeamos las opciones para el select */}
          <option value="" disabled hidden>
            {placeholder}
          </option>
          {options.map((option, index) => (
            <option key={index} value={option[valueKey]}>
              {option[labelKey]}
            </option>
          ))}
        </select>
      ) : (
        <div className="relative">
          <input
            type={type === "password" && showPassword ? "text" : type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={`w-full ${
              label ? "py-4" : "py-3"
            } px-4 rounded-[9px] bg-[#F9FAFB] text-[10px] poppins-regular ${
              label ? "placeholder-[#C9C9C9]" : "placeholder-[#8F99A6]"
            } focus:outline-none focus:ring-2 focus:ring-blue-500 tracking-wider`}
            style={{
              color: value === "" ? "#C9C9C9" : "",
            }}
            disabled={disabled}
            {...props}
          />
          {type === "password" && (
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute top-1/2 transform -translate-y-1/2 right-4 text-gray-500 focus:outline-none"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomTextInput;
